import React from "react"
import ach1 from "../../assets/images/about/01.png"
import ach2 from "../../assets/images/about/02.png"
import ach3 from "../../assets/images/about/03.jpg"
import ach4 from "../../assets/images/about/04.jpg"
import ach5 from "../../assets/images/about/05.png"
import ach6 from "../../assets/images/about/06.jpg"
import ach7 from "../../assets/images/about/07.jpg"
import ach8 from "../../assets/images/about/08.jpg"
import ach9 from "../../assets/images/about/09.jpg"
import ach10 from "../../assets/images/about/10.jpg"
import ach11 from "../../assets/images/about/11.jpg"
import ach12 from "../../assets/images/about/12.jpg"
import ach13 from "../../assets/images/about/13.jpg"
import ach14 from "../../assets/images/about/14.jpg"
import ach15 from "../../assets/images/about/15.jpg"
import ach16 from "../../assets/images/about/16.jpg"
import ach17 from "../../assets/images/about/17.jpg"
import ach18 from "../../assets/images/about/18.jpg"
import ach19 from "../../assets/images/about/19.jpg"
import ach20 from "../../assets/images/about/20.jpg"
import ach21 from "../../assets/images/about/21.jpg"
import ach22 from "../../assets/images/about/22.jpg"
import ach23 from "../../assets/images/about/23.jpg"
import ach24 from "../../assets/images/about/24.jpg"
import ach25 from "../../assets/images/about/25.jpg"
import ach26 from "../../assets/images/about/26.jpg"
import ach27 from "../../assets/images/about/27.jpg"
import ach28 from "../../assets/images/about/28.jpg"
import ach29 from "../../assets/images/about/29.jpg"
import ach30 from "../../assets/images/about/30.jpg"
import ach31 from "../../assets/images/about/31.jpg"
import ach32 from "../../assets/images/about/32.jpg"
import ach33 from "../../assets/images/about/33.jpg"
import ach34 from "../../assets/images/about/34.jpg"
import ach35 from "../../assets/images/about/35.jpg"
import ach36 from "../../assets/images/about/36.jpg"
import ach37 from "../../assets/images/about/37.jpg"
import ach38 from "../../assets/images/about/38.jpg"
import ach39 from "../../assets/images/about/39.jpg"
import ach40 from "../../assets/images/about/40.jpg"
import ach41 from "../../assets/images/about/img-finalist-aba-award-20222.png"
import ach42 from "../../assets/images/abm-badge.png"
import ach43 from "../../assets/images/about/AwardFinal.png"

import Loadable from "@loadable/component"
const OwlCarousel = Loadable(() => import("react-owl-carousel3"))

const options = {
  loop: true,
  nav: false,
  dots: false,
  autoplayHoverPause: true,
  autoplay: true,
  margin: 30,
  navText: [
    "<i class='flaticon-left-1'></i>",
    "<i class='flaticon-right-1'></i>",
  ],
  responsive: {
    0: {
      items: 3,
    },
    768: {
      items: 4,
    },
    992: {
      items: 5,
    },
  },
}

const Achievements = props => {
  const [display, setDisplay] = React.useState(false)

  React.useEffect(() => {
    setDisplay(true)
  }, [])

  return (
    <div className="row achievements-area">
      <div className="col">
        <h3 className="heading-2">Our Achievements</h3>
        <p className="paragraph-3">
          Buying property can be stressful. We are serious about making it easy
          and helping you get a better rate, regardless of whether you purchase
          a property through one of our real estate partners or not.
          <br />
          <br />
          As a result we have won MFAA Finance Broker Business - 6+ Loan Writers
          (NSW) 2017, Best Broker Group 2014, Major Brokerage of the Year 2012,
          Australian Brokerage of the Year 2011 and is regularly featured in The
          Adviser's Top 25 Brokerages and MPA's Top 10 Independent Brokerages.
        </p>

        <div className="achievement-icons">
          {display ? (
            <OwlCarousel
              className=" achievement-carousel owl-carousel owl-theme"
              {...options}
            >
              <div className="item">
                <img src={ach43} alt="Award Final 2022 Badge" />
              </div>

              <div className="item">
                <img src={ach41} alt="Finalist ABA Award 2022 Badge" />
              </div>
              <div className="item">
                <img
                  src={ach42}
                  alt="ABW 5-Star Mortgage Innovator 2022 badge"
                />
              </div>
              <div className="item">
                <img src={ach1} alt="AFG Winner - 2016" />
              </div>
              <div className="item">
                <img src={ach2} alt="Top 25 Brokerage - 2016" />
              </div>
              <div className="item">
                <img
                  src={ach3}
                  alt="Australian Broking Awards Finalist - 2020"
                />
              </div>
              <div className="item">
                <img src={ach4} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach5} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach6} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach7} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach8} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach9} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach10} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach11} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach12} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach13} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach14} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach15} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach16} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach17} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach18} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach19} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach20} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach21} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach22} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach23} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach24} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach25} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach26} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach27} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach28} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach29} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach30} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach31} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach32} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach33} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach34} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach35} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach36} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach37} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach38} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach39} alt="achievement logo" />
              </div>
              <div className="item">
                <img src={ach40} alt="achievement logo" />
              </div>
            </OwlCarousel>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  )
}

export default Achievements
